import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-your-seat-view-tab',
  templateUrl: './your-seat-view-tab.component.html',
  styleUrls: ['./your-seat-view-tab.component.scss'],
  imports: [],
  host: {
    'class': 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class YourSeatViewTabComponent {}
